<template>
  <head>
    <meta charset="utf-8" />
    <title>Desk Birdy | Active Licences</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Header -->
          <div class="row">
            <div class="col-12">
              <div class="page-header-box mb-4">
                <h4 class="page-header-title">ACTIVE CERTIFICATES</h4>
                <p class="page-header-description">Manage active and issued alcoholic drinks licences</p>
              </div>
            </div>
          </div>

          <!-- Toolbar -->
          <ToolBarLiquor/>

          <!-- Statistics Cards -->
          <div class="row">
            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card stats-card h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <p class="text-muted mb-2 fw-semibold">Total Licences</p>
                      <h3 class="mb-0 fw-bold">{{ stats.totalApplications }}</h3>
                      <div class="d-flex align-items-center mt-2">
                        <span class="badge bg-soft-primary text-primary me-2">Active</span>
                      </div>
                    </div>
                    <div class="stats-icon bg-gradient-primary">
                      <i class="bx bx-id-card"></i>
                    </div>
                  </div>
                  <div class="progress mt-3" style="height: 4px;">
                    <div class="progress-bar bg-primary" role="progressbar" style="width: 100%"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card stats-card h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <p class="text-muted mb-2 fw-semibold">Fully Paid</p>
                      <h3 class="mb-0 fw-bold">{{ stats.paidCount }}</h3>
                      <div class="d-flex align-items-center mt-2">
                        <span class="badge bg-soft-success text-success me-2">Permit Ready</span>
                      </div>
                    </div>
                    <div class="stats-icon bg-gradient-success">
                      <i class="bx bx-check-shield"></i>
                    </div>
                  </div>
                  <div class="progress mt-3" style="height: 4px;">
                    <div class="progress-bar bg-success" role="progressbar" :style="{ width: getProgressWidth('paid') + '%' }"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card stats-card h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <p class="text-muted mb-2 fw-semibold">Pending Payment</p>
                      <h3 class="mb-0 fw-bold">{{ stats.pendingCount }}</h3>
                      <div class="d-flex align-items-center mt-2">
                        <span class="badge bg-soft-warning text-warning me-2">With Balance</span>
                      </div>
                    </div>
                    <div class="stats-icon bg-gradient-warning">
                      <i class="bx bx-wallet"></i>
                    </div>
                  </div>
                  <div class="progress mt-3" style="height: 4px;">
                    <div class="progress-bar bg-warning" role="progressbar" :style="{ width: getProgressWidth('pending') + '%' }"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card stats-card h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <p class="text-muted mb-2 fw-semibold">Total Revenue</p>
                      <h3 class="mb-0 fw-bold">{{ formatCurrency(stats.totalPaid) }}</h3>
                      <div class="d-flex align-items-center mt-2">
                        <small class="text-muted">Invoiced: {{ formatCurrency(stats.totalInvoiced) }}</small>
                      </div>
                    </div>
                    <div class="stats-icon bg-gradient-info">
                      <i class="bx bx-trending-up"></i>
                    </div>
                  </div>
                  <div class="progress mt-3" style="height: 4px;">
                    <div class="progress-bar bg-info" role="progressbar" :style="{ width: getProgressWidth('amount') + '%' }"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Table Card -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <!-- Card Header -->
                <div class="card-header bg-white border-bottom">
                  <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <!-- Left: Title with Icon -->
                    <div class="d-flex align-items-center">
                      <div class="header-icon me-3">
                        <i class="bx bx-badge-check"></i>
                      </div>
                      <div>
                        <h4 class="card-title mb-0 text-uppercase fw-bold">Active Certificates</h4>
                        <small class="text-muted">Issued and active alcoholic drinks licences</small>
                      </div>
                    </div>

                    <!-- Right: Search and Actions -->
                    <div class="d-flex flex-wrap align-items-center gap-2">
                      <div class="search-box">
                        <input v-model="search" type="text" class="form-control" placeholder="Search...">
                        <i class="bx bx-search search-icon"></i>
                      </div>

                      <div class="input-group date-input">
                        <span class="input-group-text">From</span>
                        <input v-model="dateFrom" type="date" class="form-control">
                      </div>

                      <div class="input-group date-input">
                        <span class="input-group-text">To</span>
                        <input v-model="dateTo" type="date" class="form-control">
                      </div>

                      <button @click="downloadCurrentData()" class="btn btn-primary">
                        <i class="bx bxs-download me-1"></i> {{ download }}
                      </button>

                      <button @click="showFilters = !showFilters" class="btn btn-soft-secondary">
                        <i class="bx bx-filter-alt me-1"></i> Filters
                        <i :class="showFilters ? 'bx bx-chevron-up' : 'bx bx-chevron-down'" class="ms-1"></i>
                      </button>
                    </div>
                  </div>

                  <!-- Collapsible Filters -->
                  <div v-show="showFilters" class="filter-section mt-3 pt-3 border-top">
                    <div class="row g-3">
                      <div class="col-md-3">
                        <label class="form-label small fw-semibold">Business Category</label>
                        <select @change="getTradeSubCategory($event)" class="form-select">
                          <option value="">All Categories</option>
                          <option :key="index" :value="item.incomeTypeId" v-for="(item, index) in tradeCategories">
                            {{ item.incomeTypeDescription }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <label class="form-label small fw-semibold">Sub Category</label>
                        <select @change="selectedTradeSubCategory($event)" class="form-select">
                          <option value="">All Sub Categories</option>
                          <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in tradeSubCategories">
                            {{ item.feeDescription }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <label class="form-label small fw-semibold">Sub County</label>
                        <select @change="selectedSubCounty($event)" class="form-select">
                          <option value="">All Sub Counties</option>
                          <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in subCounties">
                            {{ item.subCountyName }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <label class="form-label small fw-semibold">Ward</label>
                        <select @change="selectedWard($event)" class="form-select">
                          <option value="">All Wards</option>
                          <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in wards">
                            {{ item.wardName }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Card Body -->
                <div class="card-body p-0">
                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary mb-3" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <h5 class="text-muted">Loading licences...</h5>
                    <p class="text-muted small">Please wait while we fetch the data</p>
                  </div>

                  <!-- Empty State -->
                  <div v-else-if="applications.length === 0" class="text-center py-5">
                    <div class="empty-state-icon mb-3">
                      <i class="bx bx-folder-open"></i>
                    </div>
                    <h5 class="text-muted">No Licences Found</h5>
                    <p class="text-muted small mb-3">Sorry, we could not find any licences matching your criteria</p>
                    <button @click="resetFilters" class="btn btn-soft-primary">
                      <i class="bx bx-refresh me-1"></i> Reset Filters
                    </button>
                  </div>

                  <!-- Data Table -->
                  <div v-else class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                      <thead class="table-light">
                      <tr>
                        <th class="ps-3">#</th>
                        <th>Invoice No.</th>
                        <th>Business</th>
                        <th>Applicant</th>
                        <th>Licence Category</th>
                        <th>Location</th>
                        <th>Date Inspected</th>
                        <th>Status</th>
                        <th class="text-end">Amount</th>
                        <th>Invoiced By</th>
                        <th class="text-center">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in applications" :key="index" class="table-row-hover">
                        <td class="ps-3">
                          <span class="text-muted">{{ ((currentPage - 1) * pageSize) + index + 1 }}</span>
                        </td>
                        <td>
                          <a href="javascript:void(0)" class="fw-semibold text-primary">
                            {{ item.licenceBillNo }}
                          </a>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="avatar-circle me-2">
                              {{ getInitials(item.businessName) }}
                            </div>
                            <div>
                              <h6 class="mb-0 fw-semibold">{{ item.businessName }}</h6>
                              <small class="text-muted">ID: {{ item.businessID }}</small>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span class="fw-medium">{{ item.applicant }}</span>
                            <br>
                            <small class="text-muted">{{ item.phoneNumber }}</small>
                          </div>
                        </td>
                        <td>
                          <span class="badge bg-soft-info text-info">{{ item.licenceCategory }}</span>
                          <br>
                          <small class="text-muted">{{ item.licenceDuration }}</small>
                        </td>
                        <td>
                          <span>{{ item.subCountyName }}</span>
                          <br>
                          <small class="text-muted">{{ item.wardName }}</small>
                        </td>
                        <td>
                          <span class="text-muted">{{ formatDate(item.dateInspected) }}</span>
                        </td>
                        <td>
                          <span class="badge rounded-pill bg-success">{{ item.status }}</span>
                        </td>
                        <td class="text-end">
                          <div>
                            <span class="fw-semibold">{{ formatCurrency(item.licenceDetailAmount) }}</span>
                            <br>
                            <small :class="parseFloat(item.licenceBillBalance) > 0 ? 'text-danger' : 'text-success'">
                              Bal: {{ formatCurrency(item.licenceBillBalance) }}
                            </small>
                          </div>
                        </td>
                        <td>
                          <small class="text-muted">{{ item.issuingOfficer }}</small>
                        </td>
                        <td>
                          <div class="d-flex justify-content-center gap-1">
                            <button
                                @click="applicationDetials(item)"
                                class="btn btn-icon btn-soft-primary"
                                title="View Details"
                                data-bs-toggle="modal"
                                data-bs-target="#activeCertModal">
                              <i class="bx bx-show"></i>
                            </button>
                            <button
                                @click="printViewBill(item)"
                                class="btn btn-icon btn-soft-info"
                                title="Print Invoice">
                              <i class="bx bx-printer"></i>
                            </button>
                            <button
                                v-if="item.approved === 'true'"
                                @click="printLiquorPermit(item.businessID)"
                                class="btn btn-icon btn-soft-success"
                                title="Print Permit">
                              <i class="bx bx-certification"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-dark">
                      <tr>
                        <th colspan="2">{{ applications.length }} Applications</th>
                        <th colspan="3" class="text-success">PAID APPLICATIONS: {{ stats.paidCount }}</th>
                        <th colspan="3" class="text-warning">PENDING PAYMENTS: {{ stats.pendingCount }}</th>
                        <th class="text-end">{{ formatCurrency(stats.totalInvoiced) }}</th>
                        <th colspan="2"></th>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <!-- Card Footer - Pagination -->
                <div class="card-footer bg-white border-top" v-if="applications.length > 0">
                  <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div class="d-flex align-items-center">
                      <span class="text-muted me-2">Showing</span>
                      <span class="fw-semibold">{{ ((currentPage - 1) * pageSize) + 1 }}</span>
                      <span class="text-muted mx-1">to</span>
                      <span class="fw-semibold">{{ Math.min(currentPage * pageSize, totalItems) }}</span>
                      <span class="text-muted mx-1">of</span>
                      <span class="fw-semibold">{{ totalItems }}</span>
                      <span class="text-muted ms-1">entries</span>
                    </div>

                    <div class="d-flex align-items-center gap-2">
                      <select v-model="pageSize" class="form-select form-select-sm page-size-select">
                        <option value="10">10 / page</option>
                        <option value="25">25 / page</option>
                        <option value="50">50 / page</option>
                        <option value="100">100 / page</option>
                      </select>

                      <nav>
                        <ul class="pagination pagination-sm mb-0">
                          <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" href="javascript:void(0)" @click="prevPage">
                              <i class="bx bx-chevron-left"></i>
                            </a>
                          </li>
                          <li
                              v-for="page in visiblePages"
                              :key="page"
                              class="page-item"
                              :class="{ active: currentPage === page, disabled: page === '...' }">
                            <a class="page-link" href="javascript:void(0)" @click="page !== '...' && goToPage(page)">
                              {{ page }}
                            </a>
                          </li>
                          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <a class="page-link" href="javascript:void(0)" @click="nextPage">
                              <i class="bx bx-chevron-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>


      <!-- Active Certificate Modal Component -->
      <ActiveCertModal
          :application="application"
          :applicationStatuses="applicationStatuses"
          @print-bill="printBill"
          @print-permit="printLiquorPermit"
          @receive-payment="openPaymentModal"
      />


      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">County Billing System</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import { execute, biller, liquor, authUrl, uploadsLiqour } from "@/api";
import NavigationBar from "@/components/Navigation.vue";
import ToolBarLiquor from "@/components/liquor/ToolBarLiquor.vue";
import ActiveCertModal from "@/components/liquor/modal/ActiveCertModal.vue";
import moment from "moment";

export default {
  name: "CertAlcoholActive",
  components: { NavigationBar, ToolBarLiquor, ActiveCertModal },
  data() {
    return {
      download: 'Download',
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      totalItems: 0,
      search: '',
      dateFrom: '',
      dateTo: '',
      loading: false,
      message: null,
      showFilters: false,
      documentULR: '',
      applications: [],
      application: {},
      applicationStatuses: [],
      tradeCategories: [],
      tradeSubCategories: [],
      subCounties: [],
      wards: [],
      billDetails: {},
      stats: {
        totalApplications: 0,
        paidCount: 0,
        pendingCount: 0,
        totalInvoiced: 0,
        totalPaid: 0,
        totalBalance: 0
      }
    }
  },
  computed: {
    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      if (start > 1) {
        pages.push(1);
        if (start > 2) pages.push('...');
      }

      for (let i = start; i <= end; i++) {
        if (i !== 1 && i !== this.totalPages) {
          pages.push(i);
        } else if (i === 1 && start === 1) {
          pages.push(i);
        } else if (i === this.totalPages && end === this.totalPages) {
          pages.push(i);
        }
      }

      if (end < this.totalPages) {
        if (end < this.totalPages - 1) pages.push('...');
        pages.push(this.totalPages);
      }

      return pages;
    }
  },
  mounted() {
    this.menuAccess();
    this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
    this.dateTo = moment().format('YYYY-MM-DD');

    this.getTradeCategory();
    this.getSubCounties();
    this.getApplications("");
  },
  watch: {
    search(newVal) {
      this.getApplications(newVal);
    },
    dateFrom() {
      if (this.dateFrom && this.dateTo) {
        this.getApplications("");
      }
    },
    dateTo() {
      if (this.dateFrom && this.dateTo) {
        this.getApplications("");
      }
    },
    pageSize() {
      this.currentPage = 1;
      this.getApplications("");
    }
  },
  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Liquor Permit");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).catch(() => {});
    },

    getInitials(name) {
      if (!name) return '??';
      const words = name.trim().split(' ');
      if (words.length >= 2) {
        return (words[0][0] + words[1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    },

    formatDate(dateString) {
      if (!dateString) return '-';
      return moment(dateString).format('DD MMM YYYY');
    },

    formatCurrency(amount) {
      if (!amount) return 'KES 0';
      const num = parseFloat(amount);
      return 'KES ' + num.toLocaleString('en-KE', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    },

    formatDateString(dateString) {
      if (!dateString) return '-';
      return moment(dateString).format('DD MMM YYYY h:mm A');
    },

    getHumanDate(dateData) {
      if (dateData === "-" || !dateData) return "-";
      return new Date(Date.parse(dateData)).toDateString();
    },

    getProgressWidth(type) {
      if (this.stats.totalApplications === 0) return 0;
      switch(type) {
        case 'paid':
          return (this.stats.paidCount / this.stats.totalApplications) * 100;
        case 'pending':
          return (this.stats.pendingCount / this.stats.totalApplications) * 100;
        case 'amount':
          return this.stats.totalInvoiced > 0 ? (this.stats.totalPaid / this.stats.totalInvoiced) * 100 : 0;
        default:
          return 0;
      }
    },

    calculateLocalStats() {
      this.stats.totalApplications = this.applications.length;
      this.stats.paidCount = this.applications.filter(app => parseFloat(app.licenceBillBalance) === 0).length;
      this.stats.pendingCount = this.applications.filter(app => parseFloat(app.licenceBillBalance) > 0).length;
      this.stats.totalInvoiced = this.applications.reduce((sum, app) => sum + (parseFloat(app.licenceDetailAmount) || 0), 0);
      this.stats.totalPaid = this.applications.reduce((sum, app) => sum + (parseFloat(app.licenceReceiptAmount) || 0), 0);
      this.stats.totalBalance = this.applications.reduce((sum, app) => sum + (parseFloat(app.licenceBillBalance) || 0), 0);
    },

    resetFilters() {
      this.search = '';
      this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
      this.dateTo = moment().format('YYYY-MM-DD');
      this.getApplications("");
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getApplications("");
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getApplications("");
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getApplications("");
      }
    },

    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounties");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.subCounties = res.data.data.subCounties;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getWards(subCountyID) {
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", subCountyID);
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.wards = res.data.data.wards;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getTradeCategory() {
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("incomeTypePrefix", "SBP");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.tradeCategories = res.data.data.incomeTypes;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getTradeSubCategory(event) {
      this.getApplications(event.target.value);
      this.tradeSubCategories = [];
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", event.target.value);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.tradeSubCategories = res.data.data.feesAndCharges;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    selectedTradeSubCategory(event) {
      const data = JSON.parse(event.target.value);
      this.getApplications(data.feeId);
    },

    selectedSubCounty(event) {
      const data = JSON.parse(event.target.value);
      this.getWards(data.subCountyID);
      this.getApplications(data.subCountyName);
    },

    selectedWard(event) {
      const data = JSON.parse(event.target.value);
      this.getApplications(data.wardName);
    },

    getApplications(search) {
      this.loading = true;
      this.applications = [];
      const data = new FormData();
      data.append("function", "getApplicationsApproved");
      data.append("statusID", "5");
      data.append("printable", "true");
      data.append("search", search);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      execute(data, liquor)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.applications = res.data.data.applications;
              this.totalItems = res.data.data.totalItems.count;
              this.totalPages = Math.ceil(this.totalItems / this.pageSize);
              this.calculateLocalStats();
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message;
          });
    },

    getApplicationStatus() {
      const data = new FormData();
      data.append("function", "getApplicationStatus");
      data.append("billNo", this.application.billNo);
      execute(data, liquor)
          .then((res) => {
            if (res.data.success) {
              const statuses = res.data.data.applicationStatuses;
              const invoicingStatus = statuses.find(status => status.status === "Invoicing");
              const otherStatuses = statuses.filter(status => status.status !== "Invoicing");
              this.applicationStatuses = invoicingStatus ? [invoicingStatus, ...otherStatuses] : statuses;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    applicationDetials(item) {
      this.application = item;
      this.documentULR = uploadsLiqour + '' + this.application.minutesFile;
      this.getBill(this.application.licenceBillNo);
      this.getApplicationStatus();
    },

    getBill(billNo) {
      const data = new FormData();
      data.append("function", "getBill");
      data.append("billNo", billNo);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.billDetails = res.data.data.billDetails;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    printViewBill(item) {
      this.application = item;
      this.billDetails.billNo = item.licenceBillNo;
      this.printBill();
    },

    printBill(billNo) {
      const billNumber = billNo || this.billDetails.billNo || this.application.licenceBillNo;
      localStorage['params'] = JSON.stringify({ billNo: billNumber });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    printLiquorPermit(businessID) {
      const data = new FormData();
      data.append("function", "printLiquorPermit");
      data.append("businessID", businessID);
      execute(data, liquor)
          .then((res) => {
            if (res.data.success) {
              localStorage['params'] = JSON.stringify({ businessID: businessID });
              const routeData = this.$router.resolve({ name: 'liquor-permit' });
              window.open(routeData.href, '_blank');
            } else {
              alert("Unable to print permit. Please try again.");
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },

    openPaymentModal(billNo) {
      // Navigate to BulkReceipts with billNo as query parameter
      this.$router.push({
        name: 'bulk-receipt',
        query: { search: billNo }
      });
    },

    downloadCurrentData() {
      this.download = 'Preparing...';
      try {
        const headers = [
          'S/N', 'Invoice Number', 'Business Name', 'Business ID', 'Applicant',
          'Phone Number', 'Licence Category', 'Duration', 'Sub County', 'Ward',
          'Date Inspected', 'Status', 'Invoice Amount', 'Amount Paid', 'Balance', 'Invoiced By'
        ];

        const csvRows = [headers.join(',')];

        this.applications.forEach((item, index) => {
          const row = [
            index + 1,
            `"${item.licenceBillNo || ''}"`,
            `"${item.businessName || ''}"`,
            `"${item.businessID || ''}"`,
            `"${item.applicant || ''}"`,
            `"${item.phoneNumber || ''}"`,
            `"${item.licenceCategory || ''}"`,
            `"${item.licenceDuration || ''}"`,
            `"${item.subCountyName || ''}"`,
            `"${item.wardName || ''}"`,
            `"${this.formatDate(item.dateInspected)}"`,
            `"${item.status || ''}"`,
            item.licenceDetailAmount || 0,
            item.licenceReceiptAmount || 0,
            item.licenceBillBalance || 0,
            `"${item.issuingOfficer || ''}"`
          ];
          csvRows.push(row.join(','));
        });

        csvRows.push('');
        csvRows.push(`"TOTAL","","","","","","","","","","","",${this.stats.totalInvoiced},${this.stats.totalPaid},${this.stats.totalBalance},`);

        const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `active_licences_${this.dateFrom}_to_${this.dateTo}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);

        this.download = 'Download';
      } catch (error) {
        console.error('Error generating CSV:', error);
        this.download = 'Failed';
        setTimeout(() => { this.download = 'Download'; }, 3000);
      }
    }
  }
}
</script>

<style scoped>
/* Page Header */
.page-header-box {
  background: #f8f9fa;
  padding: 20px 24px;
  border-radius: 0;
  border-bottom: 3px solid #1a2b4a;
}

.page-header-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a2b4a;
  margin-bottom: 4px;
  letter-spacing: 0.5px;
}

.page-header-description {
  font-size: 13px;
  color: #6c757d;
  margin-bottom: 0;
}

/* Statistics Cards */
.stats-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  transition: transform 0.2s, box-shadow 0.2s;
}

.stats-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.12);
}

.stats-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #0061f2 0%, #00d2ff 100%);
}

.bg-gradient-success {
  background: linear-gradient(135deg, #00b894 0%, #00cec9 100%);
}

.bg-gradient-warning {
  background: linear-gradient(135deg, #fdcb6e 0%, #e17055 100%);
}

.bg-gradient-info {
  background: linear-gradient(135deg, #a29bfe 0%, #6c5ce7 100%);
}

/* Header Icon */
.header-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #0061f2 0%, #00d2ff 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
}

/* Search Box */
.search-box {
  position: relative;
  width: 220px;
}

.search-box input {
  padding-left: 35px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.search-box .search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
}

/* Date Input */
.date-input {
  width: auto;
}

.date-input .input-group-text {
  background: #f8fafc;
  border-color: #e2e8f0;
  font-size: 12px;
  font-weight: 600;
}

.date-input input {
  border-color: #e2e8f0;
  font-size: 13px;
}

/* Avatar Circle */
.avatar-circle {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #0061f2 0%, #00d2ff 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 12px;
  flex-shrink: 0;
}

/* Table Row Hover */
.table-row-hover:hover {
  background-color: #f0f9ff !important;
}

/* Icon Buttons */
.btn-icon {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 16px;
}

.btn-soft-primary {
  background-color: rgba(0, 97, 242, 0.1);
  color: #0061f2;
  border: none;
}

.btn-soft-primary:hover {
  background-color: #0061f2;
  color: white;
}

.btn-soft-success {
  background-color: rgba(0, 184, 148, 0.1);
  color: #00b894;
  border: none;
}

.btn-soft-success:hover {
  background-color: #00b894;
  color: white;
}

.btn-soft-info {
  background-color: rgba(108, 92, 231, 0.1);
  color: #6c5ce7;
  border: none;
}

.btn-soft-info:hover {
  background-color: #6c5ce7;
  color: white;
}

.btn-soft-warning {
  background-color: rgba(225, 112, 85, 0.1);
  color: #e17055;
  border: none;
}

.btn-soft-warning:hover {
  background-color: #e17055;
  color: white;
}

.btn-soft-secondary {
  background-color: #f1f5f9;
  color: #64748b;
  border: none;
}

.btn-soft-secondary:hover {
  background-color: #e2e8f0;
  color: #475569;
}

/* Badges */
.bg-soft-primary {
  background-color: rgba(0, 97, 242, 0.1) !important;
}

.bg-soft-success {
  background-color: rgba(0, 184, 148, 0.1) !important;
}

.bg-soft-warning {
  background-color: rgba(225, 112, 85, 0.1) !important;
}

.bg-soft-info {
  background-color: rgba(108, 92, 231, 0.1) !important;
}

/* Empty State */
.empty-state-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  color: #94a3b8;
}

/* Pagination */
.page-size-select {
  width: auto;
  min-width: 100px;
}

.pagination .page-link {
  border-radius: 6px;
  margin: 0 2px;
  border: none;
  color: #64748b;
}

.pagination .page-item.active .page-link {
  background: linear-gradient(135deg, #0061f2 0%, #00d2ff 100%);
  color: white;
}

/* Filter Section */
.filter-section {
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Modal Styles */
.modal-header-gradient {
  background: linear-gradient(135deg, #0061f2 0%, #00d2ff 100%);
  padding: 1rem 1.5rem;
}

.modal-icon {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #1a2b4a;
  display: flex;
  align-items: center;
}

/* Timeline Styles */
.timeline-track {
  display: flex;
  overflow-x: auto;
  padding: 10px 0;
  gap: 0;
}

.timeline-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 120px;
  position: relative;
  flex: 1;
}

.timeline-item:not(:last-child)::after {
  content: '';
  position: absolute;
  top: 16px;
  left: 60%;
  width: calc(100% - 20px);
  height: 2px;
  background: #e2e8f0;
}

.timeline-item.completed:not(:last-child)::after {
  background: #10b981;
}

.timeline-marker {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  z-index: 1;
  background: #e2e8f0;
  color: #64748b;
}

.timeline-item.completed .timeline-marker {
  background: #10b981;
  color: white;
}

.timeline-item.active .timeline-marker {
  background: #0061f2;
  color: white;
}

.timeline-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 8px;
}

.timeline-status {
  font-size: 12px;
  font-weight: 600;
  color: #1a2b4a;
}

.timeline-date {
  font-size: 10px;
  color: #64748b;
}

.timeline-officer {
  font-size: 10px;
  color: #94a3b8;
}

/* Info Cards */
.info-card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  height: 100%;
}

.info-card-header {
  padding: 10px 15px;
  display: flex;
  align-items: center;
  font-size: 13px;
}

.info-card-body {
  padding: 12px 15px;
  background: white;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #f1f5f9;
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 12px;
  color: #64748b;
}

.info-value {
  font-size: 13px;
  color: #1a2b4a;
  text-align: right;
}

/* Alert Soft Styles */
.alert-soft-success {
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid rgba(16, 185, 129, 0.2);
  color: #059669;
  border-radius: 10px;
}

.alert-soft-warning {
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.2);
  color: #d97706;
  border-radius: 10px;
}

.alert-heading {
  font-size: 14px;
  font-weight: 600;
}

/* Subtle Background Colors */
.bg-info-subtle {
  background: rgba(6, 182, 212, 0.1);
}

.bg-success-subtle {
  background: rgba(16, 185, 129, 0.1);
}

.bg-warning-subtle {
  background: rgba(245, 158, 11, 0.1);
}

.bg-primary-subtle {
  background: rgba(99, 102, 241, 0.1);
}

.bg-secondary-subtle {
  background: rgba(100, 116, 139, 0.1);
}

.bg-purple-subtle {
  background: rgba(139, 92, 246, 0.1);
}

.text-purple {
  color: #8b5cf6;
}

/* Modal Body Scrollbar */
.modal-body::-webkit-scrollbar {
  width: 6px;
}

.modal-body::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.modal-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}
</style>